.root {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: $radius-radi-6;
  white-space: nowrap;
  padding: 0;
  margin: 0;
  border: 0;
  overflow: hidden;
  transition: 0.3s;
  line-height: 1;

  & i {
    transition: 0.3s;
  }
}

.disabled {
  cursor: not-allowed;
}

.type--primary {
  background-color: $state-primary-active;
  border: 1px solid $state-primary-active;
  color: #fff;

  &:hover {
    background-color: $state-primary-hover;
    border: 1px solid $state-primary-active;
  }

  &:active {
    background-color: $state-primary-active;
    border: 1px solid $state-primary-selected;
  }

  &:hover:active {
    background-color: $state-primary-selected;
    border: 1px solid $state-primary-selected;
  }

  & i {
    color: #fff;
  }
}

.type--secondary {
  background-color: $fill-50;
  border: 1px solid $state-base-border;
  color: $text-primary;

  &:hover {
    background-color: $fill-200;
  }

  &:active {
    background-color: $fill-200;
    border: 1px solid $state-primary-selected;
  }

  &:hover:active {
    background-color: $fill-50;
  }

  & i {
    color: $fill-600;
  }
}

.type--ghost {
  background-color: $fill-00;
  border: 1px solid $state-primary-active;
  color: $state-primary-active;

  &:hover {
    border: 1px solid $state-primary-active;
  }

  &:active {
    border: 1px solid $state-primary-selected;
  }

  &:hover:active {
    border: 1px solid $state-primary-selected;
  }

  & i {
    color: $state-primary-active;
  }
}

.type--transparent {
  background-color: transparent;
  border: 1px solid transparent;
  color: $state-primary-active;

  & i {
    color: $state-primary-active;
  }
}

.type--destructive {
  background-color: $state-destructive-active;
  border: 1px solid $state-destructive-active;
  color: #fff;

  &:hover {
    background-color: $state-destructive-hover;
    border: 1px solid $state-destructive-hover;
  }

  &:active {
    background-color: $state-destructive-selected;
    border: 1px solid $state-destructive-selected;
  }

  &:hover:active {
    background-color: $state-destructive-active;
    border: 1px solid $state-destructive-active;
  }

  & i {
    color: #fff;
  }
}

.size--xsmall {
  font-size: 16px;

  @include square(24px);
}

.size--small {
  font-size: 16px;

  @include square(36px);
}

.size--default {
  font-size: 24px;

  @include square(44px);
}

.size--large {
  font-size: 28px;

  @include square(44px);
}

.size--xl {
  font-size: 32px;

  @include square(58px);
}

.root:disabled {
  background-color: $fill-100;
  border: 1px solid $fill-100;
  color: $state-base-disabled;
  pointer-events: none;

  & i {
    color: $state-base-disabled;
  }
}


